import { z } from 'zod'

/** pointDetail */
export const pointDetailSchema = z.object({
  /** 建立日期 */
  expireDate: z.string(),

  /**
   * 狀態
   * - 0:有效
   * - 1已過期
   */
  status: z.string(),
  /** 點數 */
  point: z.number()
})

/** detail */
export const assignBenefitsGetReturnDetailSchema = z.object({
  /** 客戶優惠券id */
  id: z.string(),
  /** 優惠券券號 */
  couponNo: z.string(),
  /** 項目名稱[英文] */
  englishName: z.string(),
  /** 項目名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 項目名稱[繁體中文] */
  traditionalName: z.string(),
  /** 使用起始時間 */
  useStartTime: z.string(),
  /** 使用截止時間 */
  useEndTime: z.string(),
  /** 點數 */
  point: z.number(),
  /** 可歸還點數 */
  returnPoint: z.number(),
  /** 已過期點數 */
  expiredPoint: z.number(),
  /** 明細 */
  pointDetail: z.array(pointDetailSchema),
  /** 歸還 */
  return: z.boolean(),
  /** 收回 */
  restore: z.boolean(),
  /** 收回並歸還 */
  returnAndRestore: z.boolean()
})

export const assignBenefitsGetReturnSchema = z.object({
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 明細 */
  detail: z.array(assignBenefitsGetReturnDetailSchema)
})

export interface AssignBenefitsGetReturnDetail
  extends z.infer<typeof assignBenefitsGetReturnDetailSchema> {}

export interface AssignBenefitsGetReturn
  extends z.infer<typeof assignBenefitsGetReturnSchema> {}

export class AssignBenefitsGetReturn {
  constructor() {
    return {
      memberCardNumber: '',
      detail: []
    }
  }
}
